import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { Bot, Edit, Plus, Search, PhoneOutgoing } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAgents from '@/hooks/useAgents';
import axiosClient from '@/utils/axiosClient';
import DataTable from '../DataTable/DataTable';
import Section from '../Section';
import { Button } from '../ui/button';

const Agents = () => {
  const navigate = useNavigate();
  const agents = useAgents();
  const agentDrawer = useModal('agent-drawer');
  const data = useMemo(() => agents.data || [], [agents.data]);

  const startCall = async (agentId: string) => {
    try {
      // get authorization token from Bland
      const authResponse = await axiosClient.post(`/v1/agents/${agentId}/authorize`);
      const { token } = authResponse.data;

      // Then create web agent call
      const response = await axiosClient.post(`/v1/agents/${agentId}/web_agent_calls`);

      // Nav to web agent with the data
      navigate('/web-agents', {
        state: {
          agentId,
          sessionToken: token,
          webAgentCallId: response.data.id,
        },
      });
    } catch (error) {
      console.error('Failed to start call:', error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Agent Name',
      },
      {
        accessorKey: 'inbound_outbound',
        header: 'Direction',
      },
      {
        accessorKey: 'phone_number',
        header: 'Phone Number',
      },
      {
        header: 'Actions',
        cell: ({
          row,
        }: {
          row: {
            original: {
              id: string;
            };
          };
        }) => (
          <div className="flex items-center gap-2">
            <Button onClick={() => startCall(row.original.id)}>
              <PhoneOutgoing />
              Start Call
            </Button>
            <Button asChild>
              <Link to={`/agents/${row.original.id}`}>
                <Search />
                View
              </Link>
            </Button>
            <Button
              onClick={() => {
                agentDrawer.show({ agent: row.original });
              }}
            >
              <Edit />
              Edit
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Bot />
          <div className="text-lg font-bold">Call Agents</div>
        </div>
        <Button className="ml-auto" onClick={() => agentDrawer.show()}>
          <Plus />
          Add Agent
        </Button>
      </div>
      <Section>
        <DataTable data={data} columns={columns} model={agents} />
      </Section>
    </>
  );
};

export default Agents;
